export function binaryIncludes(value: number, includes: number): boolean {
  return (value & includes) === includes
}
